import type { Address } from '@/modules/address/domain/Address';
import type { IdentificationDocumentType } from '@/modules/shared/types/IdentificationDocumentType';

export interface Customer {
  id: string;
  customerNumber: string;
  externalId: string;
  email: string;
  firstName: string;
  middleName: string;
  lastName: string;
  title?: string;
  dateOfBirth: string;
  companyName?: string;
  vatId?: string;
  addresses: Address[];
  defaultShippingAddressId: string;
  shippingAddressIds: string[];
  defaultBillingAddressId: string;
  billingAddressIds: string[];
  isEmailVerified: boolean;
  salutation?: string;
  cognitoUserId?: string;
  rut: string;
  documentType?: IdentificationDocumentType;
  documentID?: string;
  originalRegistrationDate: Date;
  enabled: boolean;
  passportNumber?: string;
  customerSegment?: string;
  migratedFromSalesforce: boolean;
  sendNotifications: boolean;
  smartCustomerAddress?: string;
  nickName?: string;
  phone?: string;
  autoRegisteredGuest?: boolean;
  autoRegisteredAccountActivated?: boolean;
  acceptedTermsAndConditions: boolean;
  customerTags?: CustomerTags[];
  customerScopes?: string[];
}

export enum CustomerTags {
  CENCOSUD_EMPLOYEE = 'cencosudEmployee'
}
